const general = {
  LINKEDIN_CHARS_RESTRICTION: 3000,
  DEFAULT_COLOR: {
    hex: "#000000",
    rgb: { r: 0, g: 0, b: 0, a: 1 },
    hsl: { a: 1, h: 0, l: 0, s: 0 }
  },
  DEFAULT_TRANSPARENT_COLOR: { hex: "#000000", rgb: { r: 0, g: 0, b: 0, a: 0.5 }, hsl: { a: 1, h: 0, l: 0, s: 0 } },
  DEFAULT_EFFECT: "None"
};

export default general;
